import styled from '@emotion/styled';
import theme from '../theme';
import { LangContext } from '../context/LangContext'; 
import { DeviceContext } from '../context/DeviceContext'; 
import { useContext, useEffect, useRef, useState } from 'react';
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { ReactComponent as Burger } from '@assets/burger.svg';
import { ReactComponent as GetItOn } from '@assets/getItOn.svg';
import { Link, useLocation, useNavigate } from 'react-router-dom';



/*
${theme.breakpoints.lg} {
    background-color:red;
}
*/

const NavbarStyle = styled.div`
    height:88px;
    background-color: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(5px);
    color:white;        
    width:100%;        
    position: fixed; 
    z-index: 10;    
    font-size: 1.375rem;

    ${theme.breakpoints.xl_1920} {
        font-size: 20px;
    }

    ${theme.breakpoints.xl} {        
        height:auto;
    }
`;

const NavbarInner = styled.div`
    padding: 0 7%;
    margin:auto;
    height:100%;
    display: flex;
    align-items: center;
    justify-content: space-between;     

    ${theme.breakpoints.xl} {
        height:56px;        
        padding:8px 16px;
        margin:auto;                
        display: flex;
        align-items: center;
        // justify-content: space-between;
    }
`;

const NavbarLeft = styled.div`
    display: flex;
    align-items: center;
    gap:60px;
`;

const NavbarLeftImgBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const NavbarLeftMenuBox = styled.div`
    ${theme.breakpoints.xl} {
        display:none;
    }

    a{
        color:white;
        text-decoration:none;
        transition:all 0.4s ease;


        &:hover{
            display:inline-block;
            scale: 1.05;
            color:#FF6F1E;
        }
    }
`;

const NavbarRight = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;    
    text-align: center;     
`;

const NavbarRightImgBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    ${theme.breakpoints.xl} {
        display:none;
    }
`;

const NavbarRightSelectBox = styled.div`
    width:186px;
    height:52px;
    display: flex;        
    align-items: center;
    justify-content: space-between;
    padding:0px 20px;
    border: 1px solid white;
    border-radius: 6px;        
    margin: 0 30px 0 12px;
    position:relative;

    div{
        display: flex;
        align-items: center;
        justify-content: center;
    }

    ${theme.breakpoints.xl} {
        width:auto;
        height:4px;
        display: flex;        
        align-items: center;
        justify-content: space-between;
        padding:14px 8px;
        border-radius: 6px;        
        margin: 0 16px 0 0;
        position:relative;        
        font-size:.75rem;
        gap:4px;

        div{
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

`;

const NavbarLanguageBox = styled.div`
    width:226px;
    position:absolute;
    top:60px;
    left:0;
    background:#222;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    div{
        width:100%;
        height:32px;
        padding:10px;
    }

    ${theme.breakpoints.xl} {
        width:82px;
        position:absolute;
        top:50px;
        left:0px;
        background:#222;
        
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        z-index: 5;

        div{
            padding: 11.5px 18px;
        }
    }

`;

const NavbarRightButtonBox = styled.div`
    margin-right:16px;    
    transition:all 0.2s ease;

    &:active{                
        display:inline-block;
        scale: 1.1;
    }

    a{
        color:white;
        text-decoration:none;
    }
`;
const NavbarRightButton = styled.div`
    display: flex;
    width: 292px;
    height: 52px;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    border: 1px solid #FFF;
    background: linear-gradient(180deg, #FB8937 0.43%, #D13B0C 100.43%);
    box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.25);            

    ${theme.breakpoints.xl} {
        display: flex;
        width: 112px;
        height: 32px;
        // font-size:.75rem;        
        font-size:12px;        

        justify-content: center;
        align-items: center;
        border-radius: 6px;
        background: linear-gradient(180deg, #FB8937 0.43%, #D13B0C 100.43%);
        box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.25);        
    }
`;
const NavbarMobileMenu = styled.div`
    display:none;
    z-index: 999;

    img{
        width:36px;
        height:36px;
        cursor:pointer;
    }

    ${theme.breakpoints.xl}{
        display:flex;
        align-items:center;
        justify-content:center;
        padding:10px 5px;
    }
`;

const BurgerMenu = styled.div`
    background: rgba(0, 0, 0, 0.9);    
    backdrop-filter: blur(10px);

    position: absolute;
    top:0;
    left:100%;
    color:white;
    // height:100vh;
    //height: calc(100vh - ${({ toolbarHeight }) => toolbarHeight}px);
    
    min-height: 100vh;
    min-heght: -webkit-fill-available;

    //height: 100vh;
    //height: -webkit-fill-available;
    //height: available;

    width: 100%;
    transition: all .2s ease;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    font-size: 24px;

    div img{
        height:90px;
    }

    &.active{
        left:0;
    }
`;

const BurgerMenuIcon = styled.div`
    margin:20px auto;
    display:flex;
    gap:24px;
`;

const BurgetMenuHr = styled.div`
    width:100%;    
    border:.5px solid #3a3838;
`;

const BurgerMenuTitle = styled.div`
    display:flex;
    flex-direction:column;
    gap:10px;

    div {
        font-size: 24px;
        
        line-height: 165%; /* 39.6px */
    }

    div:first-of-type{
        margin-top:20px;
    }

    div:last-child{
        margin-bottom:20px;
    }
`;

const BurgerStoreBox = styled.div`
    margin-top:20px;
    display:flex;
    flex-direction:column;
    gap:12px;    
    padding-bottom:50px;
`;


export default function Navbar({sectionRefs, setNavIndex , setActiveIndex}) {

  const navigate = useNavigate();
  const location = useLocation();
  const { selectLanguage, setSelectLanguage } = useContext(LangContext);  
  const { isMobile, toolbarHeight } = useContext(DeviceContext);    
  const [openLanguage, setOpenLanguage] = useState(false);  
  const [open, setOpen] = useState(false);
  
  const setNavbar = (mode) => {
    if(mode){
        document.body.style.overflow = "hidden";
    }else{
        document.body.style.overflow = "unset";
    }
    setOpen(mode);
  }

  const clickNavbarLogo = () => {   
    console.log('clickNavbarLogo'); 
    setActiveIndex(isMobile ? 0 : 1);
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
  }

  const selectBoxFunc = () => {         
    setOpenLanguage(prev => !prev)
  }
  
  const handleMenuClick = (index) => {
    console.log('handleMenuClick' + sectionRefs[index].current.offsetTop);
    window.scrollTo({
        top: sectionRefs[index].current.offsetTop - 50,
        behavior: 'smooth'
    });
    setActiveIndex(index);

    /*
    if(selectLanguage === '한국어'){
        window.scrollTo({
            top: sectionRefs[index].current.offsetTop - 50,
            behavior: 'smooth'
        });
        setActiveIndex(index);
    }else{
        if(isMobile){
            setActiveIndex(index);
            navigate('/')
        }else{            
            setActiveIndex(index);

            
            if(location.pathname === "/"){
                window.scrollTo({
                    top: sectionRefs[index].current.offsetTop - 50,
                    behavior: 'smooth'
                });            
            }else{
                navigate('/')
            }            
        }
    }
    */
  };
  
  return (
    <NavbarStyle>
        <NavbarInner>
            <NavbarLeft>
                <NavbarLeftImgBox>
                    <Link to="/" onClick={() => clickNavbarLogo()}>
                        <img src="/images/logo/SAGA_Rebranding_BI.png" alt="logo" style={isMobile ? {height:'40px'} : {height:'60px'} }/>
                    </Link>
                </NavbarLeftImgBox>
                {/* <NavbarLeftMenuBox>
                    <Link to="/" onClick={() => {handleMenuClick(2)}}
                    >{selectLanguage === '한국어' ? '사전예약 보상' : 'REWARD'}
                    </Link>
                </NavbarLeftMenuBox> */}
                <NavbarLeftMenuBox>

                    {selectLanguage === '한국어' ?
                        <Link to="/" onClick={() => {handleMenuClick(3)}}>
                            게임 소개  
                        </Link> 
                         :
                         <Link to="/" onClick={() => {handleMenuClick(3)}}>
                            FEATURE
                        </Link>                         
                    }
                    {/* <Link to="/"
                        ref={ref => (navRef.current[1] = ref)}
                        onClick={() => {handleMenuClick(0);}}
                    >FEATURE</Link> */}
                    {/* {selectLanguage === '한국어' ?                         
                        <ScrollLink to="section2" smooth={true} duration={500}>게임 소개</ScrollLink>
                        :
                        <Link to="/">FEATURE</Link>
                    } */}
                </NavbarLeftMenuBox>
                <NavbarLeftMenuBox>
                    {selectLanguage === '한국어' ?
                        <Link to="https://saga-api.meta-toy.world/main/api/info/rate?target=dragon&lang=KOR">
                            확률표  
                        </Link> 
                         :
                         <Link to="https://saga-api.meta-toy.world/main/api/info/rate?target=dragon&lang=ENG">
                            RATE
                        </Link>                         
                    }
                </NavbarLeftMenuBox>
                {/* {selectLanguage !== '한국어' &&                    
                    <NavbarLeftMenuBox>
                        <Link to="/metodium" 
                            //style={{ color: '#FF6F1E', textDecoration: 'none', transition: 'color 0.4s ease' }}
                            style={{
                                color: '#FF6F1E',
                                textDecoration: 'none',
                                transition: 'color 0.4s ease',
                            }}
                            onMouseEnter={e => (e.target.style.color = 'white')}
                            onMouseLeave={e => (e.target.style.color = '#FF6F1E')}
                        >
                            METODIUM
                        </Link>
                    </NavbarLeftMenuBox>
                }  */}
            </NavbarLeft>
            <NavbarRight>
                <NavbarRightImgBox><img src="/images/icon/material-symbols_language.png" alt="logo" style={{height:'40px'}}/></NavbarRightImgBox>
                <NavbarRightSelectBox  onClick={() => selectBoxFunc()}>
                    {isMobile && <img src="/images/icon/material-symbols_language.png" alt="logo" style={{height:'20px'}}/>}                    
                    <div style={{marginTop:'2px'}}>
                    {
                        isMobile && selectLanguage === 'ENGLISH' ? 'ENG' : selectLanguage
                    }
                    </div>
                    <div>
                        {!openLanguage ? <IoIosArrowDown/> : <IoIosArrowUp/>}                      
                    </div>
                    {
                    openLanguage ? 
                        <NavbarLanguageBox>                            
                            <div onClick={()=> {setSelectLanguage('ENGLISH'); setActiveIndex(isMobile ? 0 : 1); }} style={selectLanguage === 'ENGLISH' ? {color: '#FFF'} : {color:'#9E9E9E'}}>{isMobile ? 'ENG' : 'ENGLISH'}</div>
                            <div onClick={()=> {setSelectLanguage('한국어'); setActiveIndex(isMobile ? 0 : 1); }} style={selectLanguage === '한국어' ? {color: '#FFF'} :  {color:'#9E9E9E'}}>한국어</div>  
                        </NavbarLanguageBox>
                    : ''
                    }
                </NavbarRightSelectBox>
                
                {/* <NavbarRightButtonBox>
                    <Link to="https://play.carv.io/events/4dd51c33-5ab5-5586-ad5c-1e85c0d62380/detail" target='_blank'>
                        <NavbarRightButton>                   
                            <div style={{marginTop:'2px'}}>
                                {selectLanguage === '한국어' ? isMobile ? '지금 사전예약' : '사전예약 하러가기' : isMobile ? 'PRE-REGISTER' : 'PRE-REGISTER NOW'}
                            </div>
                        </NavbarRightButton>
                    </Link>
                </NavbarRightButtonBox> */}
                {isMobile &&                
                    <NavbarMobileMenu onClick={()=> {setNavbar(!open); setOpenLanguage(false);}}>
                        <Burger style={{display:'inline-block'}}/>
                    </NavbarMobileMenu>
                }

                    <BurgerMenu className={open ? "menu active" : "menu"} toolbarHeight={toolbarHeight} >
                        <div>
                            <img src="/images/logo/saga_rebranding.png" alt="" />
                        </div>
                        <BurgerMenuIcon>
                            <div><Link to="" target='_blank'><img src="/images/icon/trailer.png" alt="icon" style={{height:'32px'}}/></Link></div>
                            <div><Link to="https://discord.gg/metatoyworld" target='_blank'><img src="/images/icon/discord.png" alt="icon" style={{height:'32px'}}/></Link></div>
                            <div>
                                {selectLanguage === '한국어' 
                                ?
                                    <Link to="https://game.naver.com/lounge/Meta_Toy_DragonZ_SAGA/home" target="_blank">
                                        <img src="/images/icon/zzz.png" alt="icon"  style={{height:'32px'}}/>
                                    </Link>
                                :
                                    <Link to="https://twitter.com/MetaToyDragonZ" target='_blank'><img src="/images/icon/x.png" alt="icon" style={{height:'32px'}}/></Link>
                                }  
                                
                            </div>
                            <div>
                                <Link to={selectLanguage === '한국어' 
                                    ? 'https://sandboxnetwork.zendesk.com/hc/ko/requests/new?ticket_form_id=22568004516633'
                                    : 'https://sandboxnetwork.zendesk.com/hc/en-us/requests/new?ticket_form_id=22568004516633'}
                                    target="_blank"
                                >
                                    <img src="/images/icon/help.png" alt="icon" style={{height:'32px'}}/>
                                </Link>
                            </div>
                        </BurgerMenuIcon>
                        <BurgetMenuHr/>                        

                        <BurgerMenuTitle>
                            {selectLanguage === '한국어' ?                             
                            <>
                                <div onClick={() => {handleMenuClick(1); setNavbar(!open)}}>사전예약 보상</div>
                                <div onClick={() => {handleMenuClick(2); setNavbar(!open)}}>게임 소개</div>
                            </>
                            :
                            <>
                                <div onClick={() => {handleMenuClick(1); setNavbar(!open)}}>REWARD</div>
                                <div onClick={() => {handleMenuClick(2); setNavbar(!open)}}>FEATURE</div>
                                {/* <div>
                                    <Link to="/metodium"
                                        style={{textDecoration:'none',color:'#FF6F1E'}} 
                                        onClick={()=> setNavbar(!open)}
                                    >METODIUM</Link>
                                </div> */}
                            </>
                            }
                            
                        </BurgerMenuTitle>

                        <BurgetMenuHr/>

                        <BurgerStoreBox>
                            <Link to="https://www.marblex.io/en" target="_blank">
                                <GetItOn/>
                            </Link>
                            {/* <Link to="https://play.google.com/store/apps/details?id=com.sandboxgame.mtdz" target="_blank">
                                <img src={`/images/logo/playStore${selectLanguage === '한국어' ? '' : '_eng'}.png`} alt="download" style={{height:'54px'}}/>
                            </Link>
                            <Link to="https://apps.apple.com/kr/app/%EB%A9%94%ED%83%80-%ED%86%A0%EC%9D%B4-%EB%93%9C%EB%9E%98%EA%B3%A4%EC%A6%88-%EC%82%AC%EA%B0%80/id1670309224" target="_blank">
                                <img src={`/images/logo/appStore${selectLanguage === '한국어' ? '' : '_eng'}.png`} alt="download" style={{height:'54px'}}/>
                            </Link>
                            <Link to="https://m.onestore.co.kr/osmp/onestore/preReserveGameInfoDetail.omp?eventId=eimdycbogyad1ptz8y516pbscwhdrqjwc3tuncj3gyauoattge5depjsgcaug3jwc3ougp3o&adv_showbi=Y" target="_blank">
                                <img src={`/images/logo/oneStore${selectLanguage === '한국어' ? '' : '_eng'}.png`} alt="download" style={{height:'54px'}}/>
                            </Link>                             */}
                        </BurgerStoreBox>
                    </BurgerMenu>
                
            </NavbarRight>
        </NavbarInner>
    </NavbarStyle>
  )
}
